import React, { useState } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { FiverrLogo } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { Link, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { countriesTranslate } from '../../i18n';
import { SelectCountryModal } from '../SelectCountryModal';
import { countries as countriesMap } from '../../constants/countries';
import { useResellingProgramsContext } from '../../context';

export const Header = () => {
    const {
        resellingPrograms: { countries },
        selectedCountryState: { selectedCountry: countryCode, onSelectCountry },
    } = useResellingProgramsContext();

    const [showSelectCountry, setShowSelectCountry] = useState(false);

    const flagIcon = countriesMap.get(countryCode);

    return (
        <Stack
            as="header"
            height="80px"
            justifyContent="spaceBetween"
            alignItems="center"
            backgroundColor="white"
            paddingX="10"
            borderBottomWidth="sm"
            borderColor="grey_400"
        >
            <Link href={pathfinder('homepage')}>
                <FiverrLogo />
            </Link>
            <Button variant="ghost" onClick={() => setShowSelectCountry(true)} disabled={countries.length === 1}>
                <Stack paddingX="2" paddingY="4" alignItems="center" gap="2">
                    {flagIcon}
                    <Text fontWeight="semibold" size="b_md">
                        {countriesTranslate(countryCode)}
                    </Text>
                </Stack>
            </Button>
            <SelectCountryModal
                isOpenModal={showSelectCountry}
                onCloseModal={() => setShowSelectCountry(false)}
                countries={countries}
                defaultCountry={countryCode}
                onSelectCountry={onSelectCountry}
            />
        </Stack>
    );
};
